import React from 'react'
import Slider from 'rc-slider';
import { __, sprintf } from 'StylistParent/i18n'
import { forEach } from 'lodash';

import Label from 'Components/control-label'
import Units from 'Components/units';

import convertUnits from 'Functions/convert-units'

/* Import CSS */
import './index.scss'

class SliderControl extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			value: 0,
			max: 100,
			min: 0,
			step: 1,
			sliderMarks: {},
		}

		this.changingRange = false
	}

	changeValue = ( value ) => {
		if ( ! this.changingRange && '' !== value ) {
			// Send value up to the parent component (Control).
			value = parseFloat( value )
			this.props.changeValue( value )
			this.input.value = value
		} // Else ignore value change.
	}

	cssUnitChanged = ( cssUnit ) => {
	}

	onInputChange = ( event ) => {
		this.changeValue( event.target.value )
	}

	componentWillMount() {
		this.setSliderMarks()
		// Before mounting set min/max/step for the slider component.
		this.setSliderRange()

		// console.log( "🎛 componentDidMount – VALUE" ); console.log( this.props.value );
		this.setState( {
			value: this.props.value,
		} )
	}

	componentDidUpdate = ( prevProps, prevState ) => {

		// If unit changed, update the slider component with new min/max/step.
		if ( prevProps.currentUnit != this.props.currentUnit ) {

			this.setSliderMarks()

			const convertedValue = convertUnits( {
				valueToCovert: this.props.value,
				unitFrom: prevProps.currentUnit,
				unitInto: this.props.currentUnit,
				cssProperty: this.props.cssProperty,
				selectedEl: this.props.selectedEl,
			} )

			// Firstly we need to change the slider range,
			// and ONLY after it's done we can convert the value.
			// Changing the slider range most likely with change our value
			// as well to the wrong (max range),
			// so we need to make sure we override it in callback.
			this.setSliderRange( () =>{
				this.changeValue( convertedValue )
			} )

			// window.Stylist.iBody.
			// getComputedStyle( window.Stylist.iBody ).fontSize;
		}

		if ( prevProps.value != this.state.value ) {
			this.setState( {
				value: this.props.value,
			} )
		}
	}

	setSliderMarks = () => {
		const currentUnit = this.props.currentUnit
		const sliderMarks = this.props.advanced.marks // Object with marks details.

		if ( undefined !== sliderMarks ) {
			if ( currentUnit in sliderMarks ) {
				// Found marks defined for the current unit → set state.
				this.setState( {
					sliderMarks: sliderMarks[ currentUnit ],
				} )
			} else if ( Object.keys( this.state.sliderMarks ).length === 0 ) {
				// Remove slider marks if no apprpriate set found
				// in this.props.advanced.marks + currentUnit.
				this.setState( {
					sliderMarks: {},
				} )
			}
		}
	}

	setSliderRange = ( callback = false ) => {

		this.changingRange = true

		const currentUnit = this.props.currentUnit
		const units = this.getControlUnits()

		this.setState( {
			max: parseFloat( units[ currentUnit ].max ),
			min: parseFloat( units[ currentUnit ].min ),
			step: parseFloat( units[ currentUnit ].step )
		}, () => {

			this.changingRange = false

			if ( callback ) {
				callback()
			}
		} )
	}

	getControlUnits = () => {
		let { units } = this.props.advanced

		if ( undefined === units ) {
			units = this.getDefaultUnits()
		}

		return units
	}

	getDefaultUnits = () => {
		return {
			px: {
				step: 1,
				max: 1000,
				min: 0,
			},
			'%': {
				step: .05,
				max: 100,
				min: 0,
			},
			em: {
				step: .01,
				max: 70,
				min: 0,
			},
		}
	}

	showUnits = () => {
		if ( 'font-weight' === this.props.cssProperty ) {
			return false
		}
		return true
	}

/* 	getLineHeightUnits = () => {
		return {
			px: {
				step: 1,
				max: 100,
				min: 0,
			},
			em: {
				step: .01,
				max: 10,
				min: 0,
			},
			'': {
				step: .05,
				max: 5,
				min: 0,
			},
		}
	} */

	render() {
		const { name, cssProperty, value, currentUnit, changeUnit, cssDefault, notice, advanced } = this.props;
		const { marks, showInput } = advanced;

		const sliderMarks = undefined === marks ? {} : marks
		const sliderShowInput = undefined === showInput ? true : showInput

		const controlId = `stlst-${ cssProperty }-data`
		const isValueReady = ( false === value || undefined === value || 'number' !== typeof value ) ? false : true

		if ( isValueReady ) {
			return (

				<div id={controlId} className="stlst-slider-data" data-css={cssProperty}>
					<div ref={ ( el ) => {
						this.el = el
					} }></div>
					<Slider
						max={ this.state.max }
						min={ this.state.min }
						step={this.state.step }
						// defaultValue={ parseInt( value ) }
						marks={ this.state.sliderMarks }
						value={ this.state.value }
						onChange={ this.changeValue } />
					<div className="stlst-after" datashow={String( sliderShowInput )}>
						<input type="text"
							className="stlst-after-css stlst-after-css-val"
							autoComplete="off"
							defaultValue={ parseInt( value ) }
							// value={parseInt(value)}
							onChange={ this.onInputChange }
							ref={( input ) => this.input = input} />

						{ this.showUnits() && <Units
							cssUnits={ this.getControlUnits() }
							currentUnit={currentUnit}
							changeUnit={changeUnit}
							cssProperty={cssProperty} /> }
					</div>
				</div>
			)
		}
		return ( <div></div> )
	}
}

export default SliderControl;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/slider/index.jsx